<template>
  <v-card class="settings" style="overflow-y: auto">
    <template class="settings__body">
      <div class="pa-6">
        <p class="font--title-small font--color_light">{{ filterTitle }}</p>
        <v-radio-group v-model="status" column>
          <v-radio
            color="#88BD1F"
            class="pb-4"
            :label="item.label"
            :value="item.value"
            v-for="item in list"
            :key="item.value"
          ></v-radio>
        </v-radio-group>
      </div>
    </template>
  </v-card>
</template>

<script>
export default {
  props: {
    list: Array,
    filterTitle: String,
    value: String,
  },

  computed: {
    status: {
      get() {
        return this.value;
      },
      set(newStatus) {
        this.$emit("input", newStatus);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.settings {
  width: 288px;
  position: fixed;
  right: 0px;
  top: 64px;
  bottom: 0;
  z-index: 100;
}
@media (max-width: 950px) {
  .settings {
    top: 56px;
  }
}
.settings__body {
  height: calc(100vh - 64px);
}
.theme--light.v-label {
  color: #222733 !important;
}
</style>
